import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Button, Icon, notification } from 'antd'
import { useFormikContext } from 'formik'

import { CustomBreadcrumb } from '../../../../../../components/CustomBreadcrumb/CustomBreadcrumb'
import { RULES, validRule } from '../../../../../../constants/Entitlements'
import { getMessage } from '../../../../../../util/IntlMessages'
import { useActionType } from '../../hooks/useActionType'

export const PageHeader = () => {
  const history = useHistory()
  const params = useParams()

  const { submitForm } = useFormikContext()

  const { isNewActionType } = useActionType()

  const hasAccess = validRule(RULES.ACTION_TYPE)

  const handleSubmit = async () => {
    try {
      await submitForm()

      notification.success({
        description: getMessage('successSaveData'),
        message: getMessage('sweetAlerts.success'),
        duration: 1
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="default-header-div">
      <div className="default-header-breadcrumb">
        <CustomBreadcrumb match={{ params }} history={history} />
        <div className="default-header-buttons">
          <Button className="button-return" onClick={() => history.goBack()}>
            <Icon type="left" theme="outlined" className="default-back-icon" />
            {getMessage('back')}
          </Button>
          {hasAccess && (
            <Button type="primary" className="button-action" onClick={() => handleSubmit()}>
              {isNewActionType ? getMessage('save') : getMessage('register')}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
